import { api } from '@/helpers/apiClient'
import { logRequestFailure } from '@/helpers/request-outcome'
import { ghlCompanySettingsDtoSchema, type GhlCompanySettingsDto } from '@lib/dto/gohighlevel.dto'
import type { UpdateGhlNameFormatInput } from '@lib/input/gohighlevel.input'
import type { IGoHighLevelCompanyService } from '@/types/GoHighLevelCompanyService.types'

/** The company's GoHighLevel page (docs/gohighlevel.spec.md): what every venue shares. */
class GoHighLevelCompanyServiceImpl implements IGoHighLevelCompanyService {
  async settings(): Promise<GhlCompanySettingsDto> {
    try {
      return await api.get('/gohighlevel', ghlCompanySettingsDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to load the company’s GoHighLevel settings', {}, error)
      throw error
    }
  }

  async setNameFormat(input: UpdateGhlNameFormatInput): Promise<GhlCompanySettingsDto> {
    try {
      return await api.put('/gohighlevel/name-format', input, ghlCompanySettingsDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to save the event name format', {}, error)
      throw error
    }
  }
}

export const goHighLevelCompanyService: IGoHighLevelCompanyService = new GoHighLevelCompanyServiceImpl()
